import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { NUMBER_OF_PRODUCTS_TO_SHOW } from 'commons/constants';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import ProductCardStaticPlaceholderGroup from 'components/consumer/ProductCardStaticPlaceholderGroup';
import handleProductClick from 'components/consumer/consumer-search/algolia-insights-helpers/handleInsightsProductClick';
import useMobileColumnCount from '../state/mobileColumnCount/useMobileColumnCount';
const ProductListingGrid = () => {
  const $ = _c(30);
  const {
    filterStateKey,
    isAllDataLoading,
    isAlexandriaInitialDataLoading,
    isFinalProductCountKnown,
    loading,
    products,
    productsOnDisplay,
    productsToPreload,
    layout
  } = useProductListingPageContext();
  const mobileColumnCount = useMobileColumnCount();
  const skeletonLoaderItemsCount = products?.length > 0 && products?.length < NUMBER_OF_PRODUCTS_TO_SHOW ? NUMBER_OF_PRODUCTS_TO_SHOW - products.length : NUMBER_OF_PRODUCTS_TO_SHOW;
  let t0;
  if ($[0] !== products || $[1] !== productsToPreload) {
    t0 = [...products, ...productsToPreload.map(_temp)];
    $[0] = products;
    $[1] = productsToPreload;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const allProductsToShow = t0;
  let t1;
  if ($[3] !== isAlexandriaInitialDataLoading || $[4] !== loading || $[5] !== skeletonLoaderItemsCount) {
    t1 = (loading || isAlexandriaInitialDataLoading) && <ProductCardStaticPlaceholderGroup count={skeletonLoaderItemsCount} />;
    $[3] = isAlexandriaInitialDataLoading;
    $[4] = loading;
    $[5] = skeletonLoaderItemsCount;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== allProductsToShow || $[8] !== filterStateKey || $[9] !== isAlexandriaInitialDataLoading || $[10] !== layout || $[11] !== loading || $[12] !== productsOnDisplay) {
    t2 = !loading && !isAlexandriaInitialDataLoading && allProductsToShow?.map((t3, index) => {
      const {
        campaign,
        id,
        isClearance,
        isFavorited,
        isHidden,
        label,
        meta,
        moreVariantsCount,
        name,
        onDisplayInShowroomSlug,
        path,
        position,
        productCardKey,
        productFamily,
        productLabel,
        productType,
        quickship,
        secondaryImage,
        secondaryImageCropData,
        slug,
        variants,
        variantsToShow,
        variantsTotal,
        bypass_stock,
        algoliaMetaData: t4
      } = t3;
      const algoliaMetaData = t4 === undefined ? {} : t4;
      return <ProductCardStatic campaign={campaign} disableImageLazyLoading={isNewConsumerApp && index < NUMBER_OF_PRODUCTS_TO_SHOW} prioritizeImage={isNewConsumerApp && index === 0} enableMobileCarousel={true} filterStateKey={filterStateKey} hidden={isHidden} id={id} isClearance={isClearance} isFavorited={isFavorited} key={productCardKey} label={label} layout={layout} moreVariantsCount={moreVariantsCount} name={name} onDisplayInShowroomSlug={onDisplayInShowroomSlug} path={path} position={position} productFamily={productFamily} productLabel={productLabel} productsOnDisplay={productsOnDisplay} productType={productType} quickship={quickship} secondaryImage={secondaryImage} secondaryImageCropData={secondaryImageCropData} slug={slug} variants={variants} variantsToShow={variantsToShow} variantsTotal={variantsTotal} meta={meta} bypass_stock={bypass_stock} onClick={() => handleProductClick({
        ...algoliaMetaData,
        position: index + 1
      })} />;
    });
    $[7] = allProductsToShow;
    $[8] = filterStateKey;
    $[9] = isAlexandriaInitialDataLoading;
    $[10] = layout;
    $[11] = loading;
    $[12] = productsOnDisplay;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== filterStateKey || $[15] !== isAllDataLoading || $[16] !== loading || $[17] !== skeletonLoaderItemsCount) {
    t3 = !loading && isAllDataLoading && filterStateKey !== "no-filters--featured" && <ProductCardStaticPlaceholderGroup count={skeletonLoaderItemsCount} />;
    $[14] = filterStateKey;
    $[15] = isAllDataLoading;
    $[16] = loading;
    $[17] = skeletonLoaderItemsCount;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== isAlexandriaInitialDataLoading || $[20] !== isFinalProductCountKnown || $[21] !== loading || $[22] !== products?.length) {
    t4 = !loading && isFinalProductCountKnown && !products?.length && !isAlexandriaInitialDataLoading && <div className="p-2 font-bold">No results.</div>;
    $[19] = isAlexandriaInitialDataLoading;
    $[20] = isFinalProductCountKnown;
    $[21] = loading;
    $[22] = products?.length;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== mobileColumnCount || $[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4) {
    t5 = <ProductCardGridUI limitWidth={false} columnsOnDesktop="auto" columnsOnMobile={mobileColumnCount}>{t1}{t2}{t3}{t4}</ProductCardGridUI>;
    $[24] = mobileColumnCount;
    $[25] = t1;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  return t5;
};
export default ProductListingGrid;
function _temp(product) {
  return {
    ...product,
    isHidden: true
  };
}